import { TextInlineFormatBarProps } from '../../Types'
import { RevisionsFormatBar } from 'common/Prose/components/TextInlineFormatBar/components/FormatBars/RevisionsFormatBar'

const EditModeFormatBarContainer = (props: TextInlineFormatBarProps) => <RevisionsFormatBar {...props} />

export { EditModeFormatBarContainer as EditModeFormatBar }
